import styled from 'styled-components';

export const StyledDropdown = styled.div`
  border: 1px solid #d7e3ec;
  border-radius: 12px;
  background-color: white;
  padding: 15px;
  text-align: center;
  max-width: 300px;
  min-width: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;

  select {
    border: none;
    width: 100%;
    cursor: pointer;
    background-color: transparent;
  }
`;
